/**
 * Error statuses for cross-border orders.
 * Keep in sync with shared/src/lib/cross-border-helper.ts ERROR_STATUSES.
 */
export const CROSS_BORDER_ERROR_STATUSES = new Set([
  "AddressValidationError",
  "DeliveryError",
  "Error",
  "LabelError",
  "ProductError",
  "ZenkraftAddressError",
]);
